"use client";

import { raisableFetch } from "@nimble/react-requests/api-clients/fetch-config";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useIntercom } from "react-use-intercom";

import ProfileButton from "@/app/(discover)/components/profile-button";
import { getUseApiUserDiscoverInfoQueryKey } from "@/hooks/data/use-api-user-discover-info";
import coreApiClient from "@/lib/api-clients/core-api-client";
import { buildCsrfHeaders } from "@/lib/helpers/request-headers";
import routes from "@/lib/routes";
import { useAuth } from "@/stores/use-auth";
import { usePreserveFilters } from "@/stores/use-preserve-filters";

export default function ProfileButtonWrapper() {
  const { user, clearAuth } = useAuth();
  const router = useRouter();
  const { show } = useIntercom();
  const queryClient = useQueryClient();
  const { clearPreservedFilters } = usePreserveFilters();

  async function handleSignOut() {
    try {
      await coreApiClient.deleteApiAuth();
    } catch (error) {
      console.error(error);
      return;
    }

    clearPreservedFilters();
    clearAuth();
    queryClient.removeQueries({
      queryKey: getUseApiUserDiscoverInfoQueryKey(),
      exact: false,
    });
    router.replace(routes.getJobSearchOrigin());
  }

  async function handleReleaseHijack() {
    try {
      await raisableFetch(`/admin/hijack/release/`, {
        method: "POST",
        credentials: "include",
        headers: {
          ...buildCsrfHeaders(),
        },
      });

      window.localStorage.clear();
      // eslint-disable-next-line @next/next/no-location-assign-relative-destination
      window.location.assign(`/admin/core/user/`);
    } catch (error) {
      console.error(error);
      // eslint-disable-next-line no-alert
      window.alert(
        "Failed to release hijack. This often happens if your admin session has expired. Please log in to the admin panel again.",
      );
    }
  }

  function handleProfile() {
    router.push(routes.getProfileInfo());
  }

  if (!user) return null;

  return (
    <div>
      <ProfileButton
        fullName={user.name}
        userEmail={user.email}
        size="sm"
        onProfile={handleProfile}
        onSignOut={handleSignOut}
        onGetSupport={show}
        isHijacked={user.is_hijacked}
        onReleaseHijack={handleReleaseHijack}
      />
    </div>
  );
}
